export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/spanish.34de80d.svg";